'use strict';

var _Observable = require('rxjs/Observable');

var _utils = require('../utils');

_Observable.Observable.prototype.mapResponse = _utils.mapResponse;